export const UPDATE_NAVIGATION = 'UPDATE_NAVIGATION';
export const NAV_PAGE_DIRTY = 'NAV_PAGE_DIRTY';
export const GET_ACTIVE_ALERTS_COUNT = 'GET_ACTIVE_ALERTS_COUNT';
export const GET_ACTIVE_ALERTS_COUNT_SUCCESS = `${GET_ACTIVE_ALERTS_COUNT}_SUCCESS`;

/**
 * To set a page to dirty and show a message in case the user tries to leave the screen
 * for eg. if a user is leaving a screen without saving the changes
 * @param {object} props
 * @param {boolean} props.isDirty
 * @param {string} props.chickenExitMessageId
 * @returns {object} returns object with all filter selections
 */
export function setPageDirty({
  isDirty,
  chickenExitMessageId = 'YOU_HAVE_UNSAVED_CHANGES',
}) {
  return {
    type: NAV_PAGE_DIRTY,
    payload: {
      isDirty,
      chickenExitMessageId: isDirty ? chickenExitMessageId : null,
    },
  };
}
/**
 * Getting the number of active alerts for a particular user
 * @param {string} uuid
 * @returns {object}
 */
export function getActiveAlertCount(uuid) {
  return {
    type: GET_ACTIVE_ALERTS_COUNT,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${uuid}/active-alert-count`,
      method: 'get',
    },
  };
}

/**
 * To update the navigation state
 * @param {object} props
 * @param {string} props.menuId eg.'GROUPS'
 * @param {string} props.subMenuId eg.GroupsPlace
 * @param {string} props.helpId eg.GroupsPlace
 * @returns {object}
 */
export function updateNavigation({ menuId, subMenuId, helpId }) {
  // COR-34742: Remove GWT validation callouts (eg: Unsaved form data)
  // when navigation occurs
  try {
    window.XM_hideGWTValidations?.();
  } catch (e) {
    // No-op
  }

  return {
    type: UPDATE_NAVIGATION,
    payload: {
      menuId,
      subMenuId,
      helpId,
    },
  };
}

export const updateHelpId = helpId => ({
  type: UPDATE_NAVIGATION,
  payload: { helpId },
});
